// Yup reports missing objects at their parent path (e.g. carrier), while
// selectors display a child field (e.g. carrier.name). Prefer the closest error.
export const getValidationError = (errors, path) => {
  let candidate = path;
  while (candidate) {
    if (errors[candidate] !== undefined) return errors[candidate];
    const parent = candidate.replace(/(?:\.[^.\[\]]+|\[\d+\])$/, "");
    if (parent === candidate) break;
    candidate = parent;
  }
  return undefined;
};
